console.log('床下収納プラン');

window.addEventListener("load", () => {
    const content = document.querySelector('.plan_area');
    const sec = document.querySelector('.plan');
  
    const childHeight = content.getBoundingClientRect().height;
    console.log(childHeight);
  
    sec.style.height = childHeight + "px";
  });


const planTab = document.querySelectorAll('.tab_list');
const planCon = document.querySelectorAll('.plan_con');

planTab.forEach((tab, index) =>{
    tab.addEventListener('click', function (){
        planTab.forEach((list) =>{
            list.classList.remove('active');
        })
        planCon.forEach((con) =>{
            con.classList.remove('active');
        })
        tab.classList.add('active');
        planCon[index].classList.add('active');
    })
})
